import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerModule, ButtonModule, InputsModule } from '@xref/xref-lib';

import { XrefApiWebhookModalComponent } from './xref-api-webhook-modal.component';

@NgModule({
  declarations: [XrefApiWebhookModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    BannerModule,
    InputsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [XrefApiWebhookModalComponent],
})
export class XrefApiWebhookModalModule {}
